import { updateLinksAttributes, isLocalUrl } from '../utils/handleAttributes';
import { getWindowSize } from '../utils/helpers';

function autoEventFeed() {
  const widgetName = 'autoEventFeed';
  const widgetOpts = autoEventFeedOpts;
  const $widget = $(`#${widgetName}`);
  const $container = $widget;

  $widget.append(`<div class="multiFeatureContent"></div>`);

  $widget.MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    lazyLoadImages: false,
    maxItemsVisible: 5,
    isResponsive: false,
    allEventsLink: false,
    link: getWindowSize(800) ? [''] : ['all'],
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      const widgetData = data;

      if (widgetData.length == 0) {
        $('body').addClass('manualfeed-no-data');
        $widget.remove();
        $('.events-countdown-container').remove();
      } else {
        createCustomEvents(widgetName, data, $container);
        $('.btn-container').appendTo($container);
      }
    },
  });
}

function createCustomEvents(widgetName, items, $container) {
  $(`#${widgetName} .featureItem`).each(function (i) {
    const $item = $(this).empty().appendTo($container);
    const { Date: dateWidget, Name, URL, ImageURL, Purchaseable } = items[i];

    const dateData = parseEventDate(dateWidget);

    $item.append(buildEventInfoLayout(Name, ImageURL, URL, Purchaseable));

    if (dateData.hasDate) {
      $item.find('.event-info').append(buildEventDateLayout(dateData));
    } else {
      $item.find('.event-info').addClass('no-date');
    }
    applyAriaLabel($item, Name, URL, dateData);

    if (!URL) {
      $item.addClass('void-link');
    }

    if (!getWindowSize(800)) {
      setEventLink($item, URL, Name);
    }
  });
  $(`#${widgetName} .featureItem`).appendTo('#autoEventFeed .multiFeatureContent');
}

function parseEventDate(widgetDate) {
  if (!widgetDate) {
    return { hasDate: false };
  }

  const parts = widgetDate.split('-').map((p) => p.trim());

  const start = extractDate(parts[0]);
  const end = parts[1] ? extractDate(parts[1]) : null;

  return {
    hasDate: true,
    startMonth: start.month,
    startDay: start.day,
    endMonth: end?.month || null,
    endDay: end?.day || null,
  };
}

function extractDate(str) {
  if (!str) return { month: '', day: '' };

  const clean = str.split(',')[0].trim();
  const [month, day] = clean.split(' ');

  return {
    month: month?.substring(0, 3) || '',
    day: day || '',
  };
}

function setEventLink($item, url, title) {
  if (!url) $item.addClass('void');
  updateLinksAttributes(url, title, $item);
}

function applyAriaLabel($item, title, url, dateData) {
  const dateText = buildAriaDate(dateData);
  const externalText = url && !isLocalUrl(url) ? ' (opens in a new tab)' : '';

  const label = dateText ? `${dateText} - ${title}${externalText}` : `${title}${externalText}`;

  $item.attr('aria-label', label);
}

function buildAriaDate({ hasDate, startMonth, startDay, endMonth, endDay }) {
  if (!hasDate) return '';

  const start = `${convertMonth(startMonth)} ${normalizeDay(startDay)}`;

  if (!endMonth || !endDay) return start;

  if (startMonth === endMonth) {
    return `${start} to ${normalizeDay(endDay)}`;
  }

  return `${start} to ${convertMonth(endMonth)} ${normalizeDay(endDay)}`;
}

function buildEventInfoLayout(title, imagePath, url, purchasableBtn) {
  return `
    <div class="image-container">
      <img src="${imagePath || `${FULLCLIENTTHEMEPATH}/images/no-image-available.jpg`}" alt="${title}">
      <div class="overlay">
      ${url ? `<a href="${url}" class="button alternative-btn" ${updateLinksAttributes(url, title)}>More</a>` : ''}
      ${purchasableBtn ? `<a href="${url}" class="button alternative-btn" ${updateLinksAttributes(url, title)}>Buy Now</a>` : ''}
      </div>
    </div>

    <div class="event-info">
      <span class="event-name">${title}</span>
    </div>
  `;
}

function buildEventDateLayout({ startMonth, startDay }) {
  return `
      <div class="event-date" aria-hidden="true">
        <span class="month">${startMonth}</span>
        <span class="day">${startDay}</span>
      </div>`;
}

const monthsFull = {
  Jan: 'January',
  Feb: 'February',
  Mar: 'March',
  Apr: 'April',
  May: 'May',
  Jun: 'June',
  Jul: 'July',
  Aug: 'August',
  Sep: 'September',
  Oct: 'October',
  Nov: 'November',
  Dec: 'December',
};

function convertMonth(month) {
  return monthsFull[month] || month;
}

function normalizeDay(day) {
  return Number.parseInt(day, 10);
}

export default function updateManualFeed() {
  let isMobile;

  function triggerFeature() {
    const matches = globalThis.matchMedia('(max-width: 800px)').matches;
    if (matches === isMobile) return;
    isMobile = matches;

    $('#autoEventFeed .multiFeatureContent').remove();
    autoEventFeed();
  }
  triggerFeature();

  $(globalThis).on('resize', triggerFeature);
}
